import React, { useState, useEffect } from 'react';
import './style.less';
import { useInitializeConfiguration } from './utils/hooks/useInitializeConfiguration'
import { Spin } from 'antd';
import Login from './components/login/Login';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import ProtectedPage from './pages/ProtectedPage';
import {useFetch, ApiType} from './utils/hooks/useFetch'
import EmailValidatePage from './pages/EmailValidatePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CharacterBuilderPage from './pages/CharacterBuilderPage';
import LarpTOMMenu from './components/menu/LarpTOMMenu';
import CharacterPage from './pages/CharacterPage';
import PhotoOverview from './pages/PhotoOverview';
import RegistrationsPage from './pages/RegistrationsPage';
import WikiPage from './pages/WikiPage';
import RegistrationPage from './pages/RegistrationPage';

export default function App() {

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const [appState, AppDispatch] = useInitializeConfiguration(setIsLoading);
  const [doFetch] = useFetch();


  useEffect(() => {
    AppDispatch({ type: "SETSELECTEDPAGE", payload: "Home" })
  },     //eslint-disable-next-line
  [])

  useEffect(() => {

    if(!isLoading){
      const url = `${ApiType.CORE}/Account/GetCurrentUser`;

      doFetch(url)
          .then((response) => {
              if(response.isSuccess) {
                  AppDispatch({ type: "LOGIN", payload: response.result })
              }
              setIsLoadingUser(false);
          })
    } 

  },    //eslint-disable-next-line
   [isLoading])

  useEffect(() => {
      if(appState.user !== undefined) {

        doFetch("/api/Configuration/GetAll")
          .then((response) => configurationsLoaded(response.isSuccess, response.result))
  
          function configurationsLoaded(isSuccess, result) {
            if(isSuccess) {
              AppDispatch({ type: "SETCONFIGURATIONS", payload: result})
            }
          }
      }
    },     //eslint-disable-next-line
    [appState.user])


  if(isLoading || isLoadingUser) {
    return <Spin />
  }
  const urlParams = new URLSearchParams(window.location.search);
  const characterId = urlParams.get('id'); 

  return (
    <>
    
    <div className="main">
        
      <Router basename={`${process.env.PUBLIC_URL}`}>

      <div className="main2">
      {appState.user !== undefined && 
         <LarpTOMMenu />}
      
      <div className="gridbody">
      
        <Switch>
          <Route path={`/${appState.appName}/login`} component={Login} />
          <ProtectedPage path={`/${appState.appName}/Profile`} startingUrl={`/${appState.appName}/Profile`}>
              <ProfilePage />
          </ProtectedPage>
          <Route path={`/${appState.appName}/validate-email`} component={EmailValidatePage} />
          <Route path={`/${appState.appName}/forgot-password`} component={ForgotPasswordPage} />
          <Route path={`/${appState.appName}/reset-password`} component={ResetPasswordPage} />
          <ProtectedPage path={`/${appState.appName}/wiki`} startingUrl={`/${appState.appName}/wiki`}>
              <WikiPage />
          </ProtectedPage>
          <ProtectedPage path={`/${appState.appName}/character-builder`} startingUrl={`/${appState.appName}/character-builder`}>
              <CharacterBuilderPage />
          </ProtectedPage>
          <ProtectedPage path={`/${appState.appName}/character`} startingUrl={`/${appState.appName}/character?id=${characterId}`}>
              <CharacterPage />
          </ProtectedPage>
          <ProtectedPage path={`/${appState.appName}/photos`} startingUrl={`/${appState.appName}/photos`}>
              <PhotoOverview />
          </ProtectedPage>
          <ProtectedPage path={`/${appState.appName}/registration/event`} startingUrl={`/${appState.appName}/registration/event?id=${characterId}`}>
              <RegistrationPage />
          </ProtectedPage>
          <ProtectedPage path={`/${appState.appName}/registration`} startingUrl={`/${appState.appName}/registration`}>
              <RegistrationsPage />
          </ProtectedPage>
          <ProtectedPage path={`/${appState.appName}/`} startingUrl={`/${appState.appName}/`}>
              <HomePage />
          </ProtectedPage>
          <ProtectedPage path={`/`} startingUrl={`/`}>
              <HomePage />
          </ProtectedPage>
        </Switch>
        </div>
        </div>
      </Router>
    </div>
    </>
  );
}